import {Resource, ResponseSerialize} from 'simpli-web-sdk'
import {Cargo} from '@/model/resource/Cargo'
import {PanelUser} from '@/model/resource/PanelUser'

export class CargoAuditNote extends Resource {
  idAuditPk: number = 0

  note: string | null = null
  creationDate: string | null = null

  @ResponseSerialize(Cargo)
  cargo: Cargo | null = null

  @ResponseSerialize(PanelUser)
  panelUser: PanelUser | null = null

  get $id() {
    return this.idAuditPk
  }
  set $id(val) {
    this.idAuditPk = val
  }

  get $tag() {
    return String(this.idAuditPk)
  }

  get idPanelUserFk() {
    if (!this.panelUser) return 0
    return this.panelUser.$id
  }

  set idPanelUserFk(val) {
    if (!this.panelUser) this.panelUser = new PanelUser()
    this.panelUser.$id = val
  }

  get idCargoFk() {
    if (!this.cargo) return 0
    return this.cargo.$id
  }

  set idCargoFk(val) {
    if (!this.cargo) this.cargo = new Cargo()
    this.cargo.$id = val
  }
}
